// Libs
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
// App
import { isRouterPathMatchingRoute } from 'app-shared/lib/utils';
import { SHOP_ADMIN_PAGES_URLS } from '@/fragments/shop-administration/shop-administration.constants';
import { useCreateSubscriptionBillingPortalSession } from 'app-shared/lib/api/user-access';
import { useSignOut } from '@/api/auth';
import { AUTHORITY } from 'app-shared/lib/api/user-access/account';
import { hasAuthority } from 'app-shared/lib/api/user-access/auth/auth.utils';

export const useAccountMenu = () => {
  const pathname = usePathname();
  const {
    data: redirectUrl,
    execute: executeCreateSubscriptionBillingPortalSession,
  } = useCreateSubscriptionBillingPortalSession();
  const { execute: executeSignOut } = useSignOut();
  const { data: session } = useSession();
  const isUserGlobalAdmin = hasAuthority(session, AUTHORITY.GLOBAL_ADMIN);

  useEffect(() => {
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }, [redirectUrl]);

  const createBillingPortalSession = () => {
    executeCreateSubscriptionBillingPortalSession({
      redirectUrl: SHOP_ADMIN_PAGES_URLS['shop-details'],
    });
  };

  const signOut = () => {
    const signOutResult = executeSignOut({ callbackUrl: '/' });

    return signOutResult;
  };

  const isSelected = (route: string) => {
    const isRouteSelected = isRouterPathMatchingRoute(pathname, route);

    return isRouteSelected;
  };

  return {
    createBillingPortalSession,
    signOut,
    isSelected,
    isUserGlobalAdmin,
  };
};
